import React, { useState, useEffect } from 'react';

import { r2_updateData } from '../../Helpers/r2_requests';

import { converDateWithTime } from '../../Helpers/helpers';

import { APIROOT } from '../../Helpers/configs';

import ViewUploads from '../Upload/ViewUploads';

import { defineTicketNumber } from '../../Helpers/helpers';
import CabinetDisplayInfo from '../CommonComponents/CabinetDisplayInfo';

// import RepairTicketCustomer from './RepairTicketCustomer';
// import RepairTicketCabinet from './RepairTicketCabinet';
// import RepairTicketType from './RepairTicketType';
// import RepairTicketProcess from './RepairTicketProcess';

import { useLocation, useNavigate } from 'react-router-dom';

import { GetAuth } from '../../Auth/AuthProvider';

import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  Divider,
  Modal,
} from '@mui/material';
import { AddToPhotosOutlined as AddMoreIcon, Today } from '@mui/icons-material';

import { ticketTypoTitle, ticketTypoInfo } from '../shared/commonStyle';

import UnauthorisedAccess from '../CommonComponents/UnauthorisedAccess';

const InstallArchiveView = (props) => {
  const [open3, setOpen3] = useState(false);
  const handleOpen3 = () => setOpen3(true);
  const handleClose3 = () => setOpen3(false);

  const location = useLocation();
  const ticketData = location.state;
  const navigateBack = useNavigate();

  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function

  const [forceUpdate, setForceUpdate] = useState(1);

  const [useType, setUseType] = useState(localStorage.getItem('type'));

  const cancelSave = () =>
    navigateBack(`/archive`, {
      replace: true,
      state: 'install',
    });

  const ticketUpdate = () => {
    const nodePath = `/r2_install_tickets_archive/${location.state.id}`;
    // const dataBlob = { openticket: true };

    const path = '/archive';
    const uri = nodePath;
    r2_updateData({
      uri: uri,
      dataBlob: { openticket: true },
      cancelEdit: () => {},
      setForceUpdate,
      navigateBack,
      path: path,
      logout: logout,
      enqNotification: enqNotification,
      updateMessage: 'Archive ticket re-opened',
      action_message: 'done',
      type: 'install ticket',
      state: 'install',
    });
  };

  return useType === 'technician' ? (
    <UnauthorisedAccess />
  ) : (
    <Box
      style={{
        minHeight: '20vh',
        maxWidth: '100%',
        textAlign: 'left',
        border: 'solid 2px #354775',
        background: '#ebedf8',
        borderRadius: '5px',
      }}
    >
      <Typography
        style={{
          background: '#354775',
          padding: '15px',
          border: 'solid 2px #354775',
          color: '#ffffff',
        }}
        variant='h5'
      >
        TICKET NR:{' '}
        {ticketData.id === null
          ? 'New Ticket'
          : defineTicketNumber(ticketData.ticket_type, ticketData.id, '5', 'I')}
      </Typography>

      <Box
        name='customerDetails'
        style={{
          minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'left',
          background: '#ebedf8',
          borderRadius: '5px',
          padding: '15px',
        }}
      >
        <Box>
          <Grid container sx={{ marginTop: '15px' }}>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Category:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {location.state.customer_category_name}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Customer Name:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {location.state.customer_name}
              </Typography>
            </Grid>
          </Grid>
          <Grid container sx={{ marginTop: '15px' }}>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Address:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {location.state.customer_address}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Branch Code:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {location.state.customer_branchcode}
              </Typography>
            </Grid>
          </Grid>
          <Grid container sx={{ marginTop: '15px' }}>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Contact Person:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {location.state.customer_contact_name}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>WI Nr:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {location.state.wi_number}
              </Typography>
            </Grid>
          </Grid>
          <Grid container sx={{ marginTop: '15px' }}>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Contact Number:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {location.state.customer_contact_number}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Asset Comp:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {location.state.customer_asset_comp_name}
              </Typography>
            </Grid>
          </Grid>
          <Grid container sx={{ marginTop: '15px' }}>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Notify Me:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {location.state.notify_customer ? 'Yes' : 'No'}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Ticket Logged By:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {location.state.creator_name}
              </Typography>
            </Grid>
          </Grid>
          <Grid container sx={{ marginTop: '15px' }}>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Date Scheduled:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {location.state.date_scheduled
                  ? converDateWithTime(location.state.date_scheduled)
                  : ''}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Transporter:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {location.state.transporter}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Divider />
      <Box
        style={{
          // minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'left',
          borderRadius: '5px',
          padding: '0 15px 15px 15px',
        }}
      >
        <Grid container sx={{ marginTop: '15px' }}>
          <Grid item xs={12} lg={3}>
            <Typography style={ticketTypoTitle}>
              Problem/Issue Reported:
            </Typography>
          </Grid>
          <Grid item xs={12} lg={12}>
            <Typography
              style={ticketTypoInfo}
              size='small'
              sx={{
                width: '100%',
                padding: 0,
              }}
              required
              id='description'
            >
              {location.state.description}
            </Typography>
          </Grid>
        </Grid>
        <Typography variant='h6'>Logged Cabinets:</Typography>{' '}
        <Box>
          {location.state.serial_numbers.map((obj, index) => {
            return (
              <Box key={index} margin='10px'>
                <CabinetDisplayInfo
                  // customer={customer}
                  cabinetId={obj.id}
                  cabinetData={obj}
                />
                <Grid
                  container
                  xs={10}
                  md={10}
                  flexDirection='row'
                  rowGap={1}
                  // columnGap={1}
                  alignContent='flex-start'
                >
                  <Grid
                    sx={{ margin: '0 0 40px 0' }}
                    container
                    xs={1}
                    md={1}
                    flexDirection='row'
                    rowGap={1}
                    columnGap={1}
                    alignContent='flex-start'
                  ></Grid>
                </Grid>
                <Divider />
              </Box>
            );
          })}
        </Box>
      </Box>
      <Divider style={{ marginBottom: '15px' }} />
      <Box
        name='ticketDetails'
        style={{
          // minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'left',
          borderRadius: '5px',
          padding: '0 15px 15px 15px',
        }}
      >
        <Box
          name='customerDetails'
          style={{
            minHeight: '20vh',
            maxWidth: '100%',
            textAlign: 'left',
            background: '#ebedf8',
            borderRadius: '5px',
            padding: '15px',
          }}
        >
          <Box>
            <Grid
              container
              sx={{ marginTop: '15px', textTransform: 'capitalize' }}
            >
              <Grid item xs={12} lg={3}>
                <Typography
                  style={ticketTypoTitle}
                  sx={{ textTransform: 'capitalize' }}
                >
                  Ticket Type:
                </Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoInfo}>
                  {location.state.ticket_type}
                </Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoTitle}>
                  Subcontractor Assigned:
                </Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoInfo}>
                  {location.state.sub_assigned_name}
                </Typography>
              </Grid>
            </Grid>
            <Grid container sx={{ marginTop: '15px' }}>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoTitle}>Tech Assigned:</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoInfo}>
                  {location.state.tech_assigned_name}
                </Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoTitle}>
                  Subcontractor Contact Nr:
                </Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoInfo}>
                  {location.state.sub_assigned_number}
                </Typography>
              </Grid>
            </Grid>
            <Grid container sx={{ marginTop: '15px' }}>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoTitle}>Assistant Tech:</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoInfo}>
                  {location.state.assist_tech_assigned}
                </Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoTitle}>Purchase Order:</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoInfo}>
                  {location.state.sub_customer}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
      <Divider />
      <Box
        style={{
          //   minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'left',
          background: '#ebedf8',
          borderRadius: '5px',
          padding: '15px',
        }}
      >
        <Grid container sx={{ marginTop: '15px' }}>
          <Grid item xs={12} lg={3}>
            <Typography style={ticketTypoTitle}>Status:</Typography>
          </Grid>
          <Grid item xs={12} lg={3}>
            <Typography style={ticketTypoInfo}>
              {location.state.status}
            </Typography>
          </Grid>
          <Grid item xs={12} lg={3}>
            <Typography style={ticketTypoTitle}>Cancel Reason:</Typography>
          </Grid>
          <Grid item xs={12} lg={3}>
            <Typography style={ticketTypoInfo}>
              {location.state.cancel_reason}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Modal
        open={open3}
        onClose={handleClose3}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={uploadModalStyle}>
          <ViewUploads
            relationId={ticketData.id}
            relationType='installTickets'
          />
        </Box>
      </Modal>
      <Divider />
      <Box
        style={{
          //   minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'right',
          background: '#ebedf8',
          borderRadius: '5px',
          padding: '15px',
        }}
      >
        <Button
          sx={{ minWidth: '120px' }}
          // fullWidth
          variant='contained'
          color='btn_info'
          style={{
            margin: '15px 5px',
            fontWeight: '700',
          }}
          onClick={() => {
            handleOpen3();
          }}
        >
          View Docs
        </Button>
        <Button
          sx={{ display: location.state.cancel_reason !== '' && 'none' }}
          onClick={() => ticketUpdate()}
          variant='contained'
          color='success'
          style={{ margin: '15px 5px', fontWeight: '700' }}
        >
          Re-open
        </Button>
        <Button
          onClick={() => cancelSave()}
          variant='contained'
          //   color='success'
          style={{ margin: '15px 5px', fontWeight: '700' }}
        >
          Close
        </Button>
      </Box>
    </Box>
  );
};
export default InstallArchiveView;

const uploadModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  height: '80vh',
  overflow: 'scroll',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
